import Head from 'next/head';
import { ReactNode } from 'react';

interface Props {
  title: string;
  favicon?: string;
  children?: ReactNode;
  description?: string;
  keywords?: string;
  ogImage?: string;
}

export function Meta({ title, favicon, description, children, keywords, ogImage }: Props) {
  return (
    <Head>
      <title>{title ?? 'Wolfia - AI agent for account execs and security teams that moves deals forward'}</title>
      {
        favicon ? (
          <link rel="icon" href={favicon}/>
        ) : (
          <>
            <link rel="icon" href="/favicon.ico" sizes="any"/>
            <link rel="icon" href="/images/meta/icon.svg" type="image/svg+xml"/>
            <link rel="apple-touch-icon" href="/images/meta/apple-touch-icon.png"/>
            <link rel="manifest" href="/site.webmanifest"/>
          </>
        )
      }
      <meta name="viewport" content="width=device-width, initial-scale=1"/>
      <meta
        name="description"
        content={
          description ??
          'Wolfia is an AI agent that gives your account executives and security teams superpowers, providing instant answers to technical questions, automating security questionnaires, and completing RFPs.'
        }
      />
      {keywords && <meta name="keywords" content={keywords}/>}

      <meta property="og:type" content="website"/>
      <meta property="og:title" content={title}/>
      <meta
        property="og:description"
        content={
          description ??
          'Wolfia is an AI agent that gives your account executives and security teams superpowers, providing instant answers to technical questions, automating security questionnaires, and completing RFPs.'
        }
      />
      <meta property="og:url" content="https://wolfia.com"/>
      <meta property="og:site_name" content="Wolfia"/>
      <meta property="og:locale" content="en_US"/>

      <meta property="og:image" content={ogImage ?? "images/meta/og-image.png"}/>
      <meta property="og:image:width" content="1200"/>
      <meta property="og:image:height" content="630"/>

      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:creator" content="@wolfia_app"/>
      <meta name="twitter:title" content={title}/>
      <meta
        name="twitter:description"
        content={
          description ??
          'Wolfia is an AI agent that gives your account executives and security teams superpowers, providing instant answers to technical questions, automating security questionnaires, and completing RFPs.'
        }
      />

      <link rel="preconnect" href="https://rsms.me/"/>
      <link rel="stylesheet" href="https://rsms.me/inter/inter.css"/>

      {children}
    </Head>
  );
}
